<template>
  <div>
    <c-header></c-header>
    <div class="wrap">
      <el-dialog
        :visible.sync="dialogVisible"
        width="50%"
        :close-on-click-modal='false'
        :close-on-press-escape='false'
        :show-close='false'>
        <span slot="title" class="dialog-title">
          <span>根据国家法律要求，请阅读并同意<a href="https://cont.jd.com/pccontent/12082538" target="__blank">《JDH健康内容开放平台服务协议》</a></span>
        </span>
        <div class="authorization-body" v-html="auth_content"></div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="agree">确 定</el-button>
        </div>
      </el-dialog>
      <c-menu></c-menu>
      <div class="content">
        <router-view :key="$route.query.t"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
	import cHeader from '../../../components/header.vue'
	import cMenu from '../../../components/menu.vue'
	import { isUserAuthorization, authorizeUser } from '../../../api/user'
  import {mapState,mapMutations} from 'vuex'
	export default {
		name: 'index',
		components: {
			cHeader,
			cMenu
		},
    data(){
      return {
        dialogVisible: false,
        auth_content: `<p><p>欢迎您使用JDH健康内容开放平台！</p>
<p>为使用JDH健康内容开放平台服务（以下简称“本服务”），您应当阅读并遵守《JDH健康内容开放平台服务协议》（以下简称“本协议”）。请您务必审慎阅读、充分理解各条款内容，特别是免除或限制责任的相应条款，并选择接受或不接受。免除或限制责任条款可能以加粗形式提示您注意。</p>
<p>除非您已阅读并接受本协议所有条款，否则您无权使用本服务。您对JDH健康内容开放平台的登录、查看、发布信息等行为视为您已阅读并同意本协议的约束。</p>
<p>&nbsp;</p>
<p>一、【协议的范围】</p>
<p>1.1本协议是您与京东健康之间关于您使用JDH健康内容开放平台（以下简称“开放平台”）所订立的协议，用于规范您和开放平台之间的权利义务关系。京东健康通过开放平台向您提供基于内容上传、发布、传播、存储相关的互联网信息服务、软件服务及其他相关服务。</p>
<p>“京东健康”是指北京京东健康有限公司及其相关服务可能涉及的运营关联公司。</p>
<p>“用户”是指在京东健康APP、京东APP上注册成为会员的用户，在本协议中也称为“您”。</p>
<p>“关联公司”是指对任何一家公司（或其他实体）而言，指受该公司控制、控制该公司或与该公司受第三方共同控制。所谓“控制”是指持有一家公司（或其他实体）超过50%股权权益或投票权，或通过协议或其他方式对该公司的运营具有实际决定权或控制权。对本协议任何一方而言，其关联公司指受其控制的直接或间接子公司（含通过VIE方式控制的子公司）。</p>
<p>1.2 本服务是指京东健康为开放平台用户上传、发布的内容提供信息展示渠道和存储服务以及对应技术支持服务。展示渠道包括但不限于京东健康APP、京东商城、京东APP、京东小程序等京东业务平台和京东的合作方平台。</p>
<p>1.3 本协议内容同时包括京东健康及开放平台已发布的或将来发布并依法通知您的各类规则、公告、通知等。上述内容一经正式发布，即为本协议不可分割的组成部分，您应当遵守。如您使用本服务，即视为您对本协议和前述内容的全部接受。</p>
<p>二、【账号开通与认证】</p>
<p>2.1 您需要使用京东账号（开通和使用本服务。若您没有京东账号，您应先注册京东账号并接受《京东用户注册协议》。本协议是《京东用户注册协议》的补充协议，若本协议与《京东用户注册协议》相冲突的，以本协议内容为准。</p>
<p>2.2在开通本服务过程中，基于信息登记、功能开通等需要您应申请开放平台认证，包括账号实名认证和账号资质认证。认证成功后，京东健康根据您的申请和提交的资料决定您可以开通的账号类别。</p>
<p>2.3您应当如实填写和提交账号开通与认证资料，完成信息登记，并对资料的真实性、合法性、准确性和有效性承担责任。京东健康依据您填写和提交的账号资料，在法律允许和本协议约定的范围内展示您的信息。如您提供服务或内容需要取得相关法律法规规定的许可或进行备案的，您应当在账号开通与认证时进行明确说明并提交相应的许可或备案证明。否则，京东健康有权拒绝或终止提供本服务，并依照本协议对违规账号进行处理。因此给京东健康、开放平台用户、京东用户或第三方造成损害的，您应当依法予以赔偿。</p>
<p>2.4如您同意使用本服务，您可以通过本服务上传、发布内容，包括但不限于图片、文字、视音频及其他各种形式的内容。同时，您同意并授权京东健康有权将您通过开放平台所上传、发布的各种形式内容，依据您的权限、设置、发布渠道及京东健康提供的产品功能等情况在相应的一个或多个渠道展示、推送给公众。前述渠道包括京东健康APP、京东JD.COM及京东APP内各频道（包括但不限于发现、发现好货、会买专辑、京东快报等）和京东健康的合作方平台渠道。开放平台归京东健康所有，京东健康可根据业务需要，在开放平台以及您发布内容的展示渠道中展示其他内容。</p>
<p>2.5如您使用本服务，您将可能使用以下功能：内容发布、内容管理、与订阅用户进行互动等。为了更好向您提供服务，您同意京东健康可以根据开放平台业务发展需要，调整上述功能。</p>
<p>三、【用户个人信息保护】</p>
<p>3.1 个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。京东健康非常重视用户个人信息保护，并将采取合理措施保护开放平台用户的个人信息。除法律法规规定的情形和为实现履行本服务所必须的功能外，未经开放平台用户许可京东健康不会向京东以外的第三方公开、透露用户个人信息。</p>
<p>3.2 为明确您制作、复制、上传、发布、传播内容的权利归属，以及可能产生的费用收取的需要，您在申请本服务过程中，可能需要填写您的真实姓名、身份证号等个人信息，请保持这些信息的真实、准确、合法、有效并注意及时更新，以便京东健康向您提供及时有效的帮助，或更好地为您提供服务。根据相关法律法规和政策，请您填写并确认真实的身份信息。若您填写的信息不完整或不准确，则可能无法使用本服务或在使用过程中受到限制。</p>
<p>3.3 京东健康将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。</p>
<p>3.4在使用本服务前，请确认您是已满18周岁的成年人，若您未满18周岁，应停止使用本服务。</p>
<p>3.5 您应对通过本服务了解、接收或接触到的包括但不限于其他开放平台用户在内的任何个人信息予以充分尊重，您不应以搜集、复制、存储、传播或以其他任何方式使用其他开放平台用户的个人信息，否则由此产生的后果由您自行承担。</p>
<p>四、【用户行为规范】</p>
<p>4.1 【内容规范】</p>
<p>4.1.1 第4.1条所述“内容”是指您使用本服务过程中所制作、复制、上传、发布、传播的任何内容，包括但不限于您的账号头像、名称、个人简介等信息及认证资料，您通过本服务上传、发布的图片、文字、视音频等各种形式内容，您与订阅用户的互动，您提供的相关链接页面，以及其他使用本服务所产生的内容。</p>
<p>4.1.2 您理解并同意，开放平台一直致力于为开放平台用户、社会公众提供文明健康、规范有序的网络环境，您不得利用开放平台制作、复制、上传、发布、传播、存储如下干扰开放平台正常运营，以及侵犯京东用户、开放平台用户或第三方合法权益的内容：</p>
<p>4.1.2.1 制作、复制、上传、发布、传播、储存违反国家法律法规禁止的内容：</p>
<p>（1）违反宪法确定的基本原则的；</p>
<p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
<p>（3）损害国家荣誉和利益的；</p>
<p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
<p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
<p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
<p>（7）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>
<p>（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
<p>（9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；</p>
<p>（10）以非法民间组织名义活动的；</p>
<p>（11）不符合《互联网用户账号名称管理规定》、《即时通信工具公众信息服务发展管理暂行规定》及不遵守法律法规、社会主义制度、国家利益、公民合法利益、公共秩序、社会道德风尚和信息真实性等要求的；</p>
<p>（12）含有法律、行政法规禁止的其他内容的。</p>
<p>4.1.2.2 制作、复制、上传、发布、传播、储存侵害他人财产权、人身权、名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</p>
<p>4.1.2.3 制作、复制、上传、发布、传播、储存涉及他人隐私、个人信息或资料的内容；</p>
<p>4.1.2.4 制作、复制、上传、发布、传播、储存骚扰信息、广告信息及垃圾信息或含有任何性或性暗示的内容；</p>
<p>4.1.2.5制作、复制、上传、发布、传播、储存其他违反法律法规、政策及公序良俗、社会公德或干扰开放平台正常运营和侵犯京东用户、开放平台用户或第三方合法权益的内容。</p>
<p>4.2 【平台使用规范】</p>
<p>4.2.1 第4.2条所述“平台使用”是指您使用本服务所进行的任何行为，包括但不限于账号开通、登录、申请认证、账号运营、内容发布以及其他使用开放平台所进行的行为。</p>
<p>4.2.2 您不得利用开放平台进行如下行为：</p>
<p>4.2.2.1 上传、发布虚假信息或进行虚假宣传的；</p>
<p>4.2.2.2 强制、诱导其他用户关注账号、点击链接页面或分享信息的；</p>
<p>4.2.2.3 虚构事实、隐瞒真相以误导、欺骗他人的；</p>
<p>4.2.2.4 侵害他人财产权、人身权、名誉权、肖像权、知识产权、商业秘密等合法权利的；</p>
<p>4.2.2.5
  填写和提交账号开通与认证资料违反本协议约定，或申请认证资料与开通信息内容不一致，以及运营行为与开通或认证信息所公示身份无关的；<br>&nbsp;
  &nbsp;4.2.2.6 未能按照开放平台规则开通和使用本服务，违反本服务运营规范或功能限制，或采取任何措施规避前述规则、规范或限制的；</p>
<p>4.2.2.7 未经京东健康书面许可利用其他开放平台用户账号、京东用户账号和开放平台任何功能，在第三方运营平台进行推广或互相推广的；</p>
<p>4.2.2.8未经京东健康书面许可使用插件、外挂或通过其他第三方工具、运营平台或任何服务接入本服务和相关系统的；</p>
<p>4.2.2.9 利用开放平台从事任何违法犯罪活动的；</p>
<p>4.2.2.10 上传、发布、传播、储存与以上行为相关的方法、工具，或对此类方法、工具进行运营，无论这些行为是否为商业目的；</p>
<p>4.2.2.11 仿冒、混淆其他开放平台用户账号昵称、头像、功能介绍或发布内容等，或冒充、利用他人名义开通开放平台账号的；</p>
<p>4.2.2.12 未经京东健康书面许可，自行或授权、允许、协助任何第三人对信息内容进行非法获取，用于包括但不限于宣传、增加阅读量、浏览量等用途的。“非法获取”是指采用包括但不限于“蜘蛛”(spider)程序、爬虫程序、拟人程序等非真实用户或避开、破坏技术措施等非正常浏览的手段、方式，读取、复制、转存、获得数据和信息内容的行为。</p>
<p>4.3【对自己行为负责】</p>
<p>您理解并同意，开放平台仅系为您提供内容上传、发布、传播及存储的平台，您必须为您账号下的一切行为负责。京东健康对您发布内容的审核（如有），仅为对美观度上的形式审查，并不表示确认您发布的内容合法、不侵权。对您发布的内容，您应负责并自行承担由此产生的所有后果，除法律有明确规定外，京东健康无须承担责任。</p>
<p>五、【账号管理】</p>
<p>5.1 开放平台账号的所有权归京东健康所有，开放平台用户完成申请开通手续后，获得开放平台账号的使用权。账号使用权禁止赠与、借用、租用、转让或售卖。开放平台账号的行为视为该账号所属实名认证主体的行为，实名认证主体对账号行为负责。</p>
<p>5.2 开放平台账号密码与您京东账号密码一致。京东健康特别提醒您应妥善保管您的账号和密码。京东健康会采取并不断更新技术措施，努力保护您的账号在服务器端的安全。您需要采取特定措施保护您的账号安全，包括但不限于妥善保管账号与密码、安装防病毒木马软件、定期更改密码等措施。当您使用完毕后，应安全退出。您同意在任何情况下不向他人透露账号及密码信息。因非京东健康原因导致账号被他人使用（包括但不限于遭受盗号、密码失窃）或信息数据泄漏的，相关责任由您自行承担。您理解并同意，在您未进行举报或提出账号申诉等方式明确告知京东健康您的账号被他人使用或存在信息数据泄漏等情况并提供相关证明材料前，京东健康有理由相信该账号的行为是您的行为。</p>
<p>5.3 在您怀疑他人在使用您的开放平台账号或密码时，您应立即修改密码并通知京东健康。如果您当前使用的开放平台账号并不是您申请开通的或未获得开放平台账号使用人合法授权的，但您却知悉该账号当前的密码，您不得用该账号登录或进行任何操作，并请您在第一时间通知京东健康或者该账号的申请开通主体。如果京东健康发现您并非该账号申请开通主体，京东健康有权在未经通知的情况下终止您使用该账号。</p>
<p>5.4 您理解并同意，为保护您及其他用户的数据安全，防止用户信息泄露、毁损、篡改或者丢失，京东健康有权对您接入的信息系统实行接入审查，包括但不限于技术水平审查、安全水平审查、主体资质审查等，并根据审查结果向您提出防入侵、防病毒等措施建议。若您的信息系统仍无法符合保护用户数据安全的要求，京东健康有权拒绝或终止提供本服务。</p>
<p>5.5 如您违反相关法律法规规定、本协议以及专项规则的约定，京东健康有权进行独立判断并随时限制、冻结或终止您对开放平台账号的使用，且根据实际情况决定是否恢复使用。由此给您带来的任何损失，由您自行承担。</p>
<p>5.6 如果您的开放平台账号被盗、密码遗忘或因其他原因导致无法正常登录，您可以按照开放平台的账号申诉途径进行申诉。京东健康将努力协助您找回账号但并不承诺您一定能通过申诉找回账号。</p>
<p>5.7 为了充分利用账号资源，如果您长期未完成实名认证、成功开通开放平台账号后未及时进行初次登录使用，或长期未登陆使用开放平台账号等情形，京东健康有权收回该账号的使用权。</p>
<p>六、【风险及免责】</p>
<p>6.1 您理解并同意：为了向您提供有效的服务，本服务会利用您终端设备的处理器和带宽等资源。本服务使用过程中可能产生数据流量的费用，用户需自行向运营商了解相关资费信息，并自行承担相关费用。</p>
<p>6.2 您在使用本服务时，须自行承担如下京东健康不可掌控的风险内容，包括但不限于：</p>
<p>6.2.1 由于受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏等不可抗拒因素可能引起的信息丢失、泄漏等风险；</p>
<p>6.2.2 您或京东健康的电脑软件、系统、硬件和通信线路出现故障；</p>
<p>6.2.3 您操作不当或通过非京东健康授权的方式使用本服务；</p>
<p>6.2.4 您发布的内容被他人转发、分享，因此等传播可能带来的风险和责任；</p>
<p>6.2.5 由于网络信号不稳定等原因，所引起的开放平台登录失败、资料同步不完整、页面打开速度慢等风险；</p>
<p>6.2.6 其他京东健康无法控制或合理预见的情形。</p>
<p>6.3 您理解并同意，开放平台用户通过开放平台转发、分享的内容可能会被其他用户或第三方复制、转载、修改或做其他用途，脱离您的预期和控制，您应充分意识到此类风险的存在，任何您不愿被他人获知的信息都不应在开放平台发布。如果相关行为侵犯了您的合法权益，您可以向开放平台举报投诉，我们将依法依约进行处理。</p>
<p>6.4 京东健康依据本协议约定获得处理违法违规内容或行为的权利，但该权利不构成京东健康的义务或承诺。由于海量信息的存在，京东健康无法保证及时发现违法违规情形或进行相应处理。</p>
<p>6.5 京东健康会根据您选择的服务类型向您提供相应的服务。您理解并同意，基于用户体验、京东健康或开放平台运营安全及健康发展等综合因素，京东健康有权选择提供服务或开展合作的对象，有权决定功能开放、数据接口和相关数据披露的对象和范围，并有权视具体情况中止或终止向有包括但不限于以下情形的开放平台用户提供本服务：</p>
<p>（1）违反法律法规规定或本协议约定的；</p>
<p>（2）影响开放平台用户或京东用户体验的；</p>
<p>（3）存在安全隐患的；</p>
<p>（4）与京东健康平台或开放平台已有主要功能或功能组件相似、相同，或可实现上述功能或功能组件的主要效用的；</p>
<p>（5）违背京东健康或开放平台运营原则或规则的。</p>
<p>七、【知识产权声明】</p>
<p>7.1您同意并授权京东健康及其关联公司在全球范围内永久、免费、不限范围和渠道的使用您在开放平台上传、发布的所有内容。您同意并授权京东健康及其关联公司可根据业务需要将您发布的内容转授权给第三方使用（包括但不限于在第三方平台进行展示）并根据实际需要对您的发布的内容进行不改变原意的优化或调整，您对此无需向京东健康支付任何费用，京东健康或第三方平台也无需向您支付任何费用。</p>
<p>7.2为向开放平台用户提供更优质的服务，京东健康有权对开放平台账号的昵称、头像、认证信息、上传发布的内容等公开非保密内容在本协议约定和法律允许的范围内进行使用，包括但不限于提供搜索、链接、传播等服务。</p>
<p>7.3 除另有特别声明外，京东健康提供本服务时所依托软件的著作权、商标权、专利权及其他知识产权均归京东健康所有。</p>
<p>7.4 京东健康在本服务中所使用的“JD.COM”、“京东”、“京东健康”、“JOY形象”图标及LOGO等商业标识，其著作权或商标权等知识产权归京东所有。</p>
<p>7.5 上述及任何本服务所包含内容的知识产权均受到法律保护，其他未经京东健康、开放平台用户或相关权利人许可的第三人，不得以任何形式进行使用或创造相关衍生作品。</p>
<p>7.6 您理解并同意，您向任何第三人分享、转发、复制开放平台内容的行为，均应遵守开放平台为此制定的规范和标准，包括但不限于展示方式应为该内容的原链接，确保附属于该内容的功能可正常使用等。</p>
<p>7.7 任何未经京东健康书面同意及权利人许可的非法获取行为，均属违法侵权行为。您确认并同意，为及时、有效地保障您基于本服务的合法权益，您同意并授权京东健康在发现您的合法权益（包括但不限于著作权、商标权、专利权等知识产权及相关权益）可能受到侵害时，有权但并非负有义务地代为向涉嫌侵权的第三人采取法律手段进行维权，授权采取的法律手段包括但不限于发函警告、提起诉讼、申请仲裁、移送侦查机关处理等。</p>
<p>八、【法律责任】</p>
<p>8.1 如果京东健康发现或收到他人举报或投诉开放平台用户违反本协议约定的，京东健康有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规账号处以包括但不限于警告、删除账号项下部分或全部关注京东用户、限制或禁止使用部分或全部功能、暂停或关闭账号、对违规内容产生的部分或全部收益进行划扣等处理，并公告处理结果。京东健康也有权依照本协议及专项规则的规定，拒绝再向该开放平台用户提供服务。除上述处理措施外，京东健康有权决定临时或永久禁止账号实名认证主体再次开通、使用开放平台账号。如果您发现任何开放平台用户违反本协议规定或以其他不当的方式使用本服务，请立即向开放平台举报或投诉。</p>
<p>8.2 您理解并同意，京东健康有权依合理判断对违反有关法律法规规定或本协议约定的行为进行处理，对违法违规的开放平台用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，开放平台用户应独自承担由此而产生的一切法律责任。</p>
<p>8.3 您理解并同意，如因您违反有关法律法规规定或者本协议之约定，尤其在因您发布的内容侵权或违法而导致京东健康及/或其关联公司受到权利人或相关人的任何形式的追诉或索赔，或受到相关政府部门的任何形式的处罚或承担任何形式的责任时，您应积极配合相关政府部门、京东健康及/或其关联公司处理相关争议事项的解决，并承担由此产生的全部法律责任，使京东健康或/及其关联公司在法律允许范围内最大限度免责。若京东健康及/或其关联公司先行向第三方支付了补偿、赔偿或承担了其他法律责任，或向政府部门支付了相应罚款，您应对京东健康或/及其关联公司的一切损失（包括但不限于京东健康或/及其关联公司因此支出的赔偿金、和解款、律师费、诉讼费等）进行赔偿。您在此同意京东健康及其关联公司有权暂缓支付未结算费用，并有权自未向您结算的费用中扣除该部分赔偿。未结算费用不足以弥补京东健康损失的，您应当予以补足。</p>
<p>九、【技术服务费】</p>
<p>9.1开放平台有权根据自身业务需要决定向您收取技术服务费的时间和费用标准。开放平台暂时免费向您提供技术服务。如未来根据业务情况需要收取技术服务费，开放平台将通过公告形式提前公布，请您实时关注开放平台公告内容。</p>
<p>9.2京东健康按照协议约定向您收取技术服务费的行为并不意味着京东健康对您的入驻条件、您发布内容的真实性、准确性、合法性、有效性等承担任何明示或暗示的保证或担保等责任。除法律有明确规定外，因您的行为而导致的任何投诉、纠纷、争议、赔偿等，您应以自己的名义独立承担所有法律责任。您作为内容创作者和/或信息展示者和/或营销推广服务者，应对自己的创作和/或展示和/或营销推广行为负责。</p>
<p>十、【其它】</p>
<p>10.1您理解并同意，京东健康可根据国家法律法规变化或业务发展需要，不时变更或修改本协议条款。届时京东健康将通过网站公告等形式将变更或修改事项于确定的生效之日7日前通知您，您可以在相关服务页面查阅、下载最新版本的条款。如您对变更或修改事项有任何意见或建议的，您可以联系京东健康予以反馈。如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用本服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用本服务，则视为您同意已生效的变更事项。</p>
<p>10.2 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。若您和京东健康之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。本协议签订地为中华人民共和国北京市大兴区。</p>
<p>10.3如果本协议中任何一条无效、或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。本协议未明示授权的其他权利仍由京东健康保留，您在行使这些权利时须另外取得京东健康的书面许可。京东健康如果未行使前述任何权利，并不构成对该权利的放弃。</p>
<p>10.4本协议中以加粗方式显著标识的条款，请您着重阅读。您勾选“同意”，即视为完全接受本协议，在点击之前请再次确认已知悉并完全理解本协议的全部内容。</p>
<p>&nbsp;</p></p>`
      }
    },
    computed:{
		  ...mapState([
			  'imgHost',
        'userInfo'
      ])
    },
    async created() {
      // await this.getContentUserInfo();
      // 未认证时不查询用户是否已授权
      if (this.userInfo?.auditStatus == 0 || this.userInfo?.auditStatus == undefined || this.userInfo?.auditStatus == 1){
        return;
      }
      isUserAuthorization({
        tenantId: this.$commonJs.getTenantId(),
        dicCode: '2'
      }).then(res => {
        console.log('isUserAuthorization', res)
        if (res.code == '0000') {
          this.dialogVisible = !res.data;
        }
      })
    },
    methods:{
			...mapMutations([
				'setUserInfo'
      ]),
      // 同意授权
      agree(){
        authorizeUser({
          tenantId: this.$commonJs.getTenantId(),
          dicCode: '2'
        }).then(res => {
          if (res) {
            this.$message.success('授权成功');
            this.dialogVisible = false;
          } else {
            this.$message.error(res.msg || '授权失败');
          }
        }).catch(err => {
          this.$message.error(err.msg || '授权失败');
        })
      }
	    // 获取用户信息
	    /*async getContentUserInfo(){
		    var res = await getContentUserInfo({
			    tenantId: String(this.$commonJs.getTenantId()),
        })
        if(res && res.pin){
          sessionStorage.setItem('user_identity',res.identity);
          sessionStorage.setItem('user_pin',res.pin);
          this.setUserInfo(res || {});
          // 如果是未认证用户
          if(res.code == '1402'){
            this.$router.push({
              path: "/index",
            });
          }
        }else{
          this.$router.push({
            path: "/logo",
            query: {
              returnUrl: window.location.href,
            },
          });
        }
	    },*/
    }
	}
</script>

<style lang="scss" scoped>
  #app {
    /*height:100%;*/
  }
  .wrap{
    position: relative;
    margin-top: 1px;
    /*overflow: hidden;*/

    .authorization-body{
      height: 50vh;
      overflow-y: scroll;
    }
    .el-dialog__body{
      padding: 0 20px;
    }
    .el-dialog__footer{
      padding: 10px;
    }
    .dialog-title {
      font-size: 16px;
      a{
        color: #409EFF;
      }
    }
    .dialog-footer{
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .cMenu{
      position: absolute;
      top: 0;
      left: 0;
      width: 180px;
      height: 100%;
      z-index: 1;
    }
    .content{
      position: relative;
      padding: 26px 25px 18px 26px;
      margin-left: 180px;
    }
  }
</style>
